import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import PagamentoFinalizadoMain from '../components/pagamento-finalizado';
const PagamentoFinalizado = () => {

  return (
    <Wrapper>
      <SEO pageTitle={'Assinar Agora'} />
      <PagamentoFinalizadoMain />
    </Wrapper>
  );
};

export default PagamentoFinalizado;